import { Injectable } from '@angular/core';

import { AutoCompleteService } from "../../shared/components/autocomplete/autocomplete.service";

@Injectable()
export class FuncionarioService {

    constructor(
        private _autocompleteService: AutoCompleteService
    ) { }

    templateResult = (function(state: any, isCreateNew: boolean) {
        var stateReturn: any,
            text: string;

        if (state.loading) {
            stateReturn = state.text;
        } else {
            if (state.id === -1) {
                if (isCreateNew) {
                    stateReturn = this._autocompleteService.setNewTagInList(state);
                } else {
                    stateReturn = this._autocompleteService.setNoCreateNew(state.text);
                }
            } else {
                if (state.text) {
                    text = state.text;
                } else {
                    var name: string;
                    if (state.pessoa) {
                        name = state.pessoa.nome;
                    }

                    text = name;
                }
                stateReturn = $('<span>' + text + '</span>');
            }
        }

        return stateReturn;
    }.bind(this));
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/funcionarios/funcionario.service.ts
 **/